import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { ApiService } from './services/api.service';
import { provideHttpClient, withInterceptors, HttpClient } from '@angular/common/http';
import { loadingInterceptor } from './interceptors/loading.interceptor';
import { AppLayoutModule } from '../shared/components/layouts/app.layout.module';
import { httpRequestInterceptor } from './interceptors/http-request.interceptor';
import { ToastService } from './services/toast.service';
import { httpErrorInterceptor } from './interceptors/http-error.interceptor';
import { MessageService } from 'primeng/api';
import { UserModule } from '../features/user/user.module';
import { SupportUserModule } from '../features/supportUser/support-user.module';
import { PupUserModule } from '../features/pupUser/pup-user.module';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../../environments/environment';
import { shareIcons } from 'ngx-sharebuttons/icons';
import { provideShareButtonsOptions } from 'ngx-sharebuttons';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, `${environment.apiUrl}/translations/`, '.json');
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AppLayoutModule,
    UserModule,
    SupportUserModule,
    PupUserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    // Global Services
    ApiService,
    ToastService,
    MessageService,

    // Global Pipes
    CurrencyPipe,

    // Global Interceptors
    provideHttpClient(withInterceptors(
      [
        loadingInterceptor,
        httpRequestInterceptor,
        httpErrorInterceptor
      ]
    )),

    // Share button Icons
    provideShareButtonsOptions(
      shareIcons()
    )
  ]
})
export class CoreModule { }
